export default __webpack_public_path__ + "static/media/auto-cash-in.b42dc88e.svg";